<template>
	<div class="pages" :style="{ height: height + 'px' }">
		<navTop></navTop>
		<div class="box">
			<div class="box-li" @click="goProgress(1,'Inspection report',isxiazai)">
				<p>Inspection report</p>
				<img src="../../assets/left.png" />
			</div>
			<div class="box-li" @click="goProgress(2,'Daily report',isxiazai)">
				<p>Daily report</p>
				<img src="../../assets/left.png" />
			</div>
			<div class="box-li" @click="goProgress(3,'Sailing Report',isxiazai)">
				<p>Sailing Report</p>
				<img src="../../assets/left.png" />
			</div>
			<div class="box-li" @click="goProgress(4,'Final report',isxiazai)">
				<p>Final report</p>
				<img src="../../assets/left.png" />
			</div>
		</div>
	</div>
</template>

<script>
import navTop from '../../components/navTop.vue';
export default {
	name: 'list',
	components: {
		navTop
	},
	data() {
		return {
			height: '',
			id: '',
			type: '',
			name:'',
			isxiazai:false,
		};
	},
	created() {
		if (!sessionStorage.getItem('uid')) {
			this.$router.push({ path: '/' });
		} else {
			this.id = this.$route.query.id;
			this.type = this.$route.query.type;
			this.height = window.innerHeight;
			this.isxiazai=this.$route.query.name
		}
		console.log(this.id,'this.id')
	},
	methods:{
		goProgress(e,name,xiazai){
			console.log(e)
			// if(!this.isxiazai){
				switch(e){
					case 1:
					return this.path(name,e,this.isxiazai)
					case 2:
					return this.path(name,e,this.isxiazai)
					case 3:
					return this.$router.push({ path: '/kh', query: { id: this.id,name:name,type:e,xiazai:xiazai  } })
					case 4:
					return this.$router.push({ path: '/zb', query: { id: this.id,name:name,type:e,xiazai:xiazai  } })

				}
			// }else{
			// 	switch(e){
			// 		case 1:
			// 		return this.path(name,e,this.isxiazai)
			// 		case 2:
			// 		return this.path(name,e,this.isxiazai)
			// 		case 3:
			// 		return window.open('http://39.105.212.82/userfiles/null/fj/reportImg/' + this.id + '.pdf')
			// 		case 4:
			// 		return window.open('http://39.105.212.82/userfiles/null/fj/reportImg/' + this.id + '.pdf')

			// 	}
			// }

		},
		path(name,e,xiazai){
			this.$router.push({ path: '/lowerList', query: { id: this.id,name:name,type:e,xiazai:xiazai } })
		}
	}

	}

</script>

<style lang="scss" scoped>
.pages {
	background: #3E414A;
	.box {
		width: 100%;
		margin: 0 auto;
		padding-top: 109px;
		box-sizing: border-box;
		.box-li {
			width: 100%;
			height: 100px;
			border: 1px solid rgba(0, 255, 255, 0.25);
			border-radius: 10px;
			background: #053134;
			margin-bottom: 28px;
			padding: 0 55px;
			box-sizing: border-box;
			display: flex;
			align-items: center;
			justify-content: space-between;
			p {
				font-size: 30px;
				color: #1bf6ff;
				line-height: 1em;
			}
			img {
				width: 23px;
				height: 41px;
				display: block;
			}
		}
		.box-li:last-child {
			margin: 0;
		}
	}
}
</style>
